package org.dronda.app.web.ui

import com.varabyte.kobweb.compose.css.BackgroundAttachment
import com.varabyte.kobweb.compose.css.backgroundAttachment
import com.varabyte.kobweb.compose.css.backgroundImage
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.boxSizing
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb

object DefaultStyles : StyleSheet() {
    init {
        "*" {
            boxSizing("border-box")
            fontFamily("sans-serif")
        }

        "body" {
            margin(0.px)
            backgroundImage(
                linearGradient(
                    LinearGradient.Direction.ToBottom
                ) {
                    add(rgb(234, 232, 255), 0.percent)
                    add(rgb(253, 232, 255), 100.percent)
                }
            )
            backgroundAttachment(BackgroundAttachment.Fixed)
        }

        "h1, h2, h3, h4, h5, h6, p" {
            margin(0.px)
            fontFamily("sans-serif")
        }
    }
}